module.exports = __webpack_public_path__ + "static/media/dryer.0ca8dd17.svg";